<template>
    <div class="ecpay-redirect-container">
      <div class="loading-spinner"></div>
      <h2>正在跳轉到綠界支付...</h2>
      <p>請稍候，系統正在處理您的請求</p>
      
      <!-- 預定義的表單，不使用動態創建 -->
      <form ref="ecpayForm" :action="actionUrl" method="POST" style="display: none;">
        <input v-for="(value, key) in formData" :key="key" type="hidden" :name="key" :value="value">
      </form>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import axios from 'axios';
  
  const route = useRoute();
  const router = useRouter();
  const ecpayForm = ref(null);
  const actionUrl = ref('');
  const formData = ref({});
  const isLoading = ref(true);
  const error = ref(null);
  
  onMounted(async () => {
    try {
      const orderId = route.query.order_id;
      if (!orderId) {
        throw new Error('缺少訂單 ID');
      }
      
      // 獲取支付表單數據
      const response = await axios.post('/api/ecpay_credit_request/', {
        order_id: orderId
      });
      
      if (response.data?.success && response.data.action_url && response.data.form_data) {
        actionUrl.value = response.data.action_url;
        formData.value = response.data.form_data;
        
        // 等待 DOM 更新
        setTimeout(() => {
          if (ecpayForm.value) {
            ecpayForm.value.submit();
          }
        }, 100);
      } else {
        throw new Error('獲取支付表單數據失敗');
      }
    } catch (err) {
      error.value = err.message || '處理支付請求時發生錯誤';
      console.error('支付跳轉錯誤:', err);
      
      // 顯示錯誤 3 秒後返回充值頁面
      setTimeout(() => {
        router.push('/recharge');
      }, 3000);
    }
  });
  </script>
  
  <style scoped>
  .ecpay-redirect-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
    padding: 20px;
  }
  
  .loading-spinner {
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  h2 {
    margin-bottom: 10px;
  }
  </style>
  